import { render, staticRenderFns } from "./AllTemplates.vue?vue&type=template&id=82930952"
import script from "./AllTemplates.vue?vue&type=script&lang=js"
export * from "./AllTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports